export const frontendVersion = __APP_VERSION__;
